export const MAX_CONTENT_WIDTH = 1920

export const BREAKPOINTS = {
  xxs: '380px',

  xs: '420px',

  // * Vertical menu bar
  vM: '600px',
  // => @media (min-width: 600px) { ... }

  sm: '640px',
  // => @media (min-width: 640px) { ... }

  // * Album Images just stack
  sI: '768px',
  // => @media (min-width: 768px) { ... }

  md: '768px',
  // => @media (min-width: 768px) { ... }

  // * Photodiary stacked
  phS: '920px',
  // => @media (min-width: 920px) { ... }

  lg: '1024px',
  // => @media (min-width: 1024px) { ... }

  xl: '1280px',
  // => @media (min-width: 1280px) { ... }

  xxl: '1400px',
  // => @media (min-width: 1280px) { ... }

  maxContent: `${MAX_CONTENT_WIDTH + 64}px`,
  // => @media (min-width: 1920px) { ... }
} as const
